import { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@primer/octicons-react';
import SideMenu from './SideMenu';
import Header2 from '../Header2';
import routes from '../../router/routers';
import '../../styles/spark-layout.css';

export default function AppShell({children}: {children: React.ReactNode}) {
    const [collapsed, setCollapsed] = useState(() => localStorage.getItem('ictu.navigation.collapsed') === 'true');
    const [mobileOpen, setMobileOpen] = useState(false);
    const [query, setQuery] = useState('');
    const updateQuery = useCallback((value: string) => {setQuery(value);if (value.trim()) setCollapsed(false);}, []);
    const [isMobile, setIsMobile] = useState(() => window.matchMedia('(max-width: 991.98px)').matches);
    const closeNavigation = useCallback(() => setMobileOpen(false), []);
    const {pathname} = useLocation();
    const workspace = useRef<HTMLDivElement>(null);
    const currentGroup = routes.find(group => group.children?.some(item => item.path &&
        (pathname === item.path || pathname.startsWith(item.path + '/'))));
    const currentPage = currentGroup?.children?.find(item => item.path &&
        (pathname === item.path || pathname.startsWith(item.path + '/')));

    useEffect(() => {localStorage.setItem('ictu.navigation.collapsed', String(collapsed));}, [collapsed]);
    useEffect(() => {
        const media = window.matchMedia('(max-width: 991.98px)');
        const onChange = () => {setIsMobile(media.matches);setMobileOpen(false);};
        media.addEventListener('change', onChange);
        return () => media.removeEventListener('change', onChange);
    }, []);
    useEffect(() => {closeNavigation();workspace.current?.scrollTo?.({top:0});}, [pathname, closeNavigation]);
    const toggleNavigation = () => {
        if (isMobile) setMobileOpen(value => !value);
        else setCollapsed(value => !value);
    };
    const hideNavigation = pathname === '/no-access';

    return (
        <div className={`appRoot spark-app ${collapsed ? 'navigationCollapsed' : ''}`}>
            <a className="skipToContent" href="#workspace-content">Đến nội dung chính</a>
            <div className="appBody">
                {!hideNavigation && <>
                    {mobileOpen && <button type="button" tabIndex={-1} className="navigationBackdrop" onClick={closeNavigation} aria-label="Đóng menu"/>}
                    <SideMenu collapsed={collapsed && !mobileOpen} mobileOpen={mobileOpen} onNavigate={closeNavigation} onExpand={() => setCollapsed(false)} query={query} onQueryChange={updateQuery}/>
                </>}
                <div className="appFrame">
                <Header2 onToggleNavigation={hideNavigation ? undefined : toggleNavigation} navigationOpen={isMobile ? mobileOpen : !collapsed}
                    query={query} onQueryChange={hideNavigation ? undefined : updateQuery}/>
                <main className="workspace" id="workspace-content" tabIndex={-1}>
                    <div className="workspaceContext">
                        <nav className="workspaceBreadcrumb" aria-label="Đường dẫn trang">
                            <Link to="/" aria-label="Trang chính"><HomeIcon size={16}/></Link>
                            {currentGroup && <><ChevronRightIcon size={13}/><span>{currentGroup.name}</span></>}
                            {currentPage && <><ChevronRightIcon size={13}/><span aria-current="page">{currentPage.name}</span></>}
                        </nav>
                    </div>
                    <div ref={workspace} className="workspaceBody"><div className="workspaceContent">{children}
                        <footer className="workspaceFooter"><span>Học bổ sung kiến thức · ICTU</span>
                        </footer>
                    </div></div>
                </main>
                </div>
            </div>
        </div>
    );
}
